export interface ExperimentConstrains {
  id: string;
  variations: Record<string, string>;
}

export type ExperimentsConstrains = Record<string, ExperimentConstrains>;

// Narrows TS keyof from string to union of keys
const factory = <T extends ExperimentsConstrains>(config: T) => config;

export const EXPERIMENTS = factory({
  test_experiment: {
    id: 'id',
    variations: {
      original: 'original',
      variation1: 'variation1',
    },
  },
  schufa_highlighted_experiment: {
    id: '4695485907206144',
    variations: {
      original: '5638960316153856',
      variation1: '4574861029277696',
    },
  },
  upsell_modal_price_decrease_experiment: {
    id: '4894142082318336',
    variations: {
      original: '4506732609667072',
      variation1: '5940106607984640',
    },
  },
  upsell_modal_partner_logo: {
    id: '4982332088647680',
    variations: {
      original: '6389706972200960',
      variation1: '6714280402223104',
    },
  },
  wohnen_plus_english_upsell: {
    id: '5569922386886656',
    variations: {
      original: '5408327832698880',
      variation1: '6534227739541504',
    },
  },
} as const);

export type Experiments = typeof EXPERIMENTS;
